<template>
  <div>
    <!--<el-date-picker
      v-model="dateArray"
      type="datetimerange"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd HH:mm:ss"
      @change="dateChange">
    </el-date-picker>
    <el-button @click="showTrackFun()" type="primary">获取车辆轨迹</el-button>
    <hr/>-->
    <div class="amap-page-container">
      <el-amap
        vid="amapDemo"
        :zoom="zoom"
        :center="center"
        class="my-vehicle-amap"
        :amap-manager="amapManager"
        :events="events"
      >
        <el-amap-marker
          v-if="mark.position.length > 0"
          :visible="mark.visible"
          :position="mark.position"
          :events="mark.events"
        >
          <div
            :class="
              `marker-vehicle ${mark.loadStatus == 1 ? 'online' : 'offline'}`
            "
            :style="`transform: rotate(${mark.direction}deg);`"
          >
            <div
              class="marker-vehicle-icon"
              :style="`transform: rotate(${-mark.direction}deg);`"
            />
          </div>
        </el-amap-marker>
        <el-amap-info-window
          v-if="mark.position.length > 0"
          :position="mark.position"
          :visible="showCurrentWindow"
          :events="windowEvents"
        >
          <div class="my-marker-title">
            {{ mark.vehicleNumber }}({{
              mark.loadStatus == 1 ? "在途" : "空载"
            }})
          </div>
          <div class="my-marker-body">
            <div>上报时间：{{ mark.locationTime }}</div>
            <div>车速：{{ mark.speed }}km/h</div>
            <div>坐标：{{ mark.position }}</div>
            <div>当前位置：{{ mark.locationAddress }}</div>
          </div>
        </el-amap-info-window>
        <template v-if="showTrack">
          <el-amap-bezier-curve
            v-for="line in lines"
            :key="line.id"
            :events="line.events"
            :path="line.path"
            :stroke-color="line.strokeColor"
            :stroke-style="line.strokeStyle"
            :stroke-opacity="line.strokeOpacity"
          />
        </template>
      </el-amap>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueAMap from "vue-amap";
let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
let AMapKey = "";
if (dataBranch) {
  if (dataBranch.partyGroupConfigCacheMap.amapKey_webJs) {
    AMapKey = dataBranch.partyGroupConfigCacheMap.amapKey_webJs.configValue;
  }
  if (dataBranch.partyGroupConfigCacheMap.amapKey_webJs_security) {
    window._AMapSecurityConfig = {
      securityJsCode:
        dataBranch.partyGroupConfigCacheMap.amapKey_webJs_security.configValue
    };
  }
}
VueAMap.initAMapApiLoader({
  key: AMapKey,
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.Geocoder"
  ],
  v: "1.4.4",
  uiVersion: "1.0"
});
Vue.use(VueAMap);
import { vHisTrack, vehicleMap } from "@/api/vehiclemap";
import { AMapManager } from "vue-amap";
import "@/assets/vehicle_map/icon.css";

const amapManager = new AMapManager();

export default {
  data() {
    return {
      amapManager: amapManager,
      events: {
        init(o) {}
      },
      dateArray: ["", ""],
      vivdata: {
        vehicleCode: "595d6d91ca694b58a9fd23e04df0b494",
        startTime: "",
        endTime: "",
        locationSource: 0
      },
      showTrack: false,
      zoom: 12,
      center: [116.380298, 35.907771],
      showCurrentWindow: false,
      windowEvents: {
        close: () => {
          this.showCurrentWindow = false;
        }
      },
      mark: {
        visible: true,
        position: [116.397451, 39.909187],
        loadStatus: 0,
        direction: 0,
        locationTime: "",
        speed: "",
        locationAddress: "",
        events: {
          click: () => {
            if (this.showCurrentWindow) {
              this.showCurrentWindow = false;
            } else {
              this.showCurrentWindow = true;
            }
          }
        }
      },
      lines: [
        {
          path: [[116.380298, 35.907771]],
          strokeDasharray: [10, 10],
          strokeColor: "#3366FF", //线颜色
          strokeOpacity: 1, //线透明度
          strokeWeight: 6, //线宽
          strokeStyle: "solid", //线样式
          events: {
            click: () => {}
          }
        }
      ]
    };
  },
  created() {},
  methods: {
    trajectory(code) {
      this.vivdata.vehicleCode = code;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.showCurrentWindow = false;
      this.mark.position = [];
      vehicleMap(this.vivdata.vehicleCode)
        .then(response => {
          if (response.data) {
            let item = response.data[0];
            if (item.longitude) {
              this.mark.position = [
                Number(item.longitude),
                Number(item.latitude)
              ];
              this.mark.loadStatus = item.loadStatus ? item.loadStatus : 0;
              this.mark.direction = item.direction ? item.direction : 0;
              this.mark.vehicleNumber = item.vehicleNumber
                ? item.vehicleNumber
                : "";
              this.mark.locationTime = item.locationTime
                ? item.locationTime
                : "";
              this.mark.speed = item.speed ? item.speed : "";
              this.mark.visible = true;
              this.mark.locationAddress = item.locationAddress
                ? item.locationAddress
                : "";
              this.center = this.mark.position;
            } else {
              this.$message({
                message: "未查询到车辆位置信息！",
                type: "error"
              });
            }
          }
          this.showTrack = true;
          loading.close();
        })
        .catch(() => {
          this.center = [116.380298, 35.907771];
          loading.close();
        });
    },
    showTrackFun() {
      if (this.vivdata.startTime && this.vivdata.endTime) {
        vHisTrack(this.vivdata).then(response => {
          let trackPath = [];
          let list = response.data;
          if (list && list.length > 0) {
            this.center = [Number(list[0].longitude), Number(list[0].latitude)];
            list.forEach((item, index) => {
              trackPath.push([item.longitude, item.latitude]);
            });
            this.lines[0].path = trackPath;
            this.showTrack = true;
          } else {
            this.$message({
              message: "该时间范围内未查询到轨迹！",
              type: "error"
            });
          }
        });
      } else {
        this.$message({ message: "请选择时间范围！", type: "error" });
      }
    },
    dateChange(arr) {
      let start = new Date(arr[0]);
      let end = new Date(arr[1]);
      if (end - start > 86400000) {
        this.$message({
          message: "所选择时间范围不能大于一天！",
          type: "error"
        });
        this.dateArray = ["", ""];
      } else {
        this.vivdata.startTime = arr[0];
        this.vivdata.endTime = arr[1];
      }
    }
  }
};
</script>
<style scoped>
.amap-page-container {
  height: 800px;
}
</style>
